<template>
  <div class="hotel_container" style="max-width: initial;">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 5rem; line-height: 5rem">
        <el-breadcrumb-item :to="{ name: 'orderList' }">{{ $t("ORDERINFO.LinkName") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ titlename }}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-container style="height: 100%; border: 1px solid #eee">
        <el-aside width="20%" style="background-color: #ffffff">
          <el-menu :default-openeds="['1', '3']" :default-active="$route.path">
            <el-sub-menu index="1">
              <template #title>{{ $t("ORDERINFO.LinkName") }}</template>
              <el-menu-item-group style="margin-top: -2rem">
                <el-menu-item index="1" @click="handleClick('myOrder')" id="li-myOrder">
                  {{ $t("ORDERINFO.MyOrderTitle") }}
                </el-menu-item>
                <el-menu-item index="1-3" @click="handleClick('departmentOrder')" id="li-departmentOrder">
                  {{ $t("ORDERINFO.DepartmentOrderTitle") }}
                </el-menu-item>
                <el-menu-item index="1-4" @click="handleClick('hotelOrder')" id="li-hotelOrder">
                  {{ $t("ORDERINFO.HotelOrderTitle") }}
                </el-menu-item>
                <el-menu-item index="" @click="$router.push('/manualOrder')">
                  {{ $t("ORDERINFO.ManualOrderTitle") }}
                </el-menu-item>
              </el-menu-item-group>
            </el-sub-menu>
          </el-menu>
        </el-aside>

        <el-container>
          <!--search Form -->
          <el-header style="height: auto">
            <div class="box"></div>
            <div class="div_select_panel" v-if="myOrderShow">
              <div>
                <div style="background-color: #ffffff; padding-left: 0.5rem">
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.Destination")
                          }}</span>
                          <destination class="myinput_inner" :returnParentValue="dataForm.city.cityName" :defaultSearchValue="dataForm.city.cityName"
                          @returnCityInfo="setDestination" 
                          :isHotCity="false" :key="destinationKey"></destination>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{ $t("MYORDER.HotelName") }}</span>
                        <el-input v-model="dataForm.hotelName" placeholder="" class="myinput_inner"></el-input>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.OrderStatus")
                        }}</span>
                        <el-select clearable v-model="dataForm.orderstatus" multiple  placeholder="" class="myselect_inner myicon_inner">
                          <el-option v-for="item in orderstatusoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.DateType")
                        }}</span>
                        <el-select v-model="dataForm.datetype" placeholder="" class="myselect_inner myicon_inner" clearable>
                          <el-option v-for="item in datetypeoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.StartDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="dataForm.startDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.EndDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="dataForm.endDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.PaymentType")
                        }}</span>
                        <el-select clearable v-model="dataForm.paymenttype" placeholder="" class="myselect_inner myicon_inner">
                          <el-option v-for="item in paymentoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.Traveler")
                        }}</span>
                        <el-input v-model="dataForm.travelerName" placeholder="" class="myinput_inner"></el-input>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.OrderNo")
                          }}</span>
                          <el-input v-model="dataForm.orderno" placeholder="" class="myinput_inner"></el-input>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :offset="18">
                      <button class="s_btn s_btn_small rmargin" v-on:click="SearchClick('myOrder')">
                        {{ $t("MYORDER.Search") }}
                      </button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="div_select_panel" name="hotelOrder" v-if="hotelOrderShow">
              <div>
                <div style="background-color: #ffffff; padding-left: 0.5rem">
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.Client")
                          }}</span>
                          <el-input @focus="showClientNamePop" readonly v-model="hotelDataForm.client" class="myinput_inner"></el-input>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.Traveler")
                        }}</span>
                        <el-input v-model="hotelDataForm.travelerName" placeholder="" class="myinput_inner"></el-input>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.Destination")
                          }}</span>
                          <destination class="myinput_inner" :returnParentValue="hotelDataForm.city.cityName" @returnCityInfo="sethotelDestination" :isHotCity="false"></destination>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.DateType")
                          }}</span>
                          <el-select v-model="hotelDataForm.datetype" placeholder="" clearable class="myselect_inner myicon_inner">
                            <el-option v-for="item in datetypeoptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.StartDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="hotelDataForm.startDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.EndDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="hotelDataForm.endDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.HotelName")
                        }}</span>
                        <el-input v-model="hotelDataForm.hotelName" placeholder="" class="myinput_inner"></el-input>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.OrderNo")
                          }}</span>
                          <el-input v-model="hotelDataForm.orderno" placeholder="" class="myinput_inner"></el-input>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.OrderStatus")
                        }}</span>
                        <el-select clearable v-model="hotelDataForm.orderstatus" multiple placeholder="" class="myselect_inner myicon_inner">
                          <el-option v-for="item in orderstatusoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.PaymentType")
                          }}</span>
                          <el-select clearable v-model="hotelDataForm.paymenttype" placeholder="" class="myselect_inner myicon_inner">
                            <el-option v-for="item in paymentoptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8"> </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8"> </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :offset="18">
                      <button class="s_btn s_btn_small rmargin" v-on:click="SearchClick('hotelOrder')">
                        {{ $t("MYORDER.Search") }}
                      </button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="div_select_panel" name="departmentOrder" v-if="departmentOrderShow">
              <div id="nav6">
                <div style="background-color: #ffffff; padding-left: 0.5rem">
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.PaymentType")
                        }}</span>
                        <el-select clearable v-model="departmentDataForm.paymenttype" placeholder="" class="myselect_inner myicon_inner">
                          <el-option v-for="item in paymentoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.Department")
                        }}</span>
                        <el-select clearable v-model="departmentDataForm.id" @change="departmentchange" class="myselect_inner myicon_inner">
                          <el-option v-for="item in departmentoptions" :key="item.id" :label="item.departmentName" :value="item.id">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.Traveler")
                          }}</span>
                          <el-select clearable v-model="departmentDataForm.travelerName" placeholder="" class="myselect_inner myicon_inner">
                            <el-option v-for="item in traveleroptions" :key="item.value" :label="item.travelerName" :value="item.travelerName">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.DateType")
                        }}</span>
                        <el-select v-model="departmentDataForm.datetype" placeholder="" clearable class="myselect_inner myicon_inner">
                          <el-option v-for="item in datetypeoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.StartDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="departmentDataForm.startDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.EndDate")
                        }}</span>
                        <el-date-picker class="el-date-picker" v-model="departmentDataForm.endDate" align="right" type="date" placeholder="yyyy/mm/dd">
                        </el-date-picker>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.Destination")
                          }}</span>
                          <destination class="myinput_inner" :returnParentValue="
                              departmentDataForm.city.cityName
                            " @returnCityInfo="setdepartDestination" :isHotCity="false"></destination>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.HotelName")
                        }}</span>
                        <el-input v-model="departmentDataForm.hotelName" placeholder="" class="myinput_inner"></el-input>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <div class="grid-content bg-purple">
                          <span class="grey_small_font">{{
                            $t("MYORDER.OrderNo")
                          }}</span>
                          <el-input v-model="departmentDataForm.orderno" placeholder="" class="myinput_inner"></el-input>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="content_size">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="grid-content bg-purple-light">
                        <span class="grey_small_font">{{
                          $t("MYORDER.OrderStatus")
                        }}</span>
                        <el-select clearable v-model="departmentDataForm.orderstatus" multiple placeholder="" class="myselect_inner myicon_inner">
                          <el-option v-for="item in orderstatusoptions" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8"> </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :offset="18">
                      <button class="s_btn s_btn_small rmargin" v-on:click="SearchClick('departmentOrder')">
                        {{ $t("MYORDER.Search") }}
                      </button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-header>
          <!--Table          -->
          <div class="div_main_table">
            <Loading :loading="orderloading" :isRelativeBrowserWin="false" />
            <el-main style="padding-top: 0; padding-bottom: 0">
              <el-button style="margin-top: 1rem" @click="clickExport" type="primary" >{{ $t("ORDERLIST.EAPORTEXCEL") }}</el-button>
              <el-checkbox v-if="$objBaseInfo.sourceType == 'CRM'" v-model="isExportRemark">导出订单备注</el-checkbox>
              <el-button style="margin-top: 1rem;margin-left:10px;" @click="showBigOrder" type="primary" v-if="isOpenBigOrder == 1">{{ $t("BIGORDER.AddBigOrder") }}</el-button>
              <el-table ref="orderListTable" :data="tableData" class="" :empty-text="$t('ORDERLIST.NoData')" width="100%" :key="isOpenBigOrder">
                <el-table-column type="selection" width="60" align="center" v-if="isOpenBigOrder == 1">
                </el-table-column>
                <el-table-column prop="date11" v-if="false"> </el-table-column>
                <el-table-column prop="date12" v-if="false"> </el-table-column>
                <el-table-column prop="date" :label="$t('ORDERLIST.OrderNo')" align="center"></el-table-column>
                <el-table-column prop="date9" :label="$t('ORDERLIST.Client')" v-if="hotelOrderShow" min-width="100" align="center"></el-table-column>
                <el-table-column prop="date8" :label="$t('ORDERLIST.OrderStatus')" align="center"></el-table-column>
                <el-table-column prop="approvalStatus" :label="$t('ORDERLIST.APPROVALSTATUS')" align="center"></el-table-column>
                <el-table-column prop="date10" :label="$t('ORDERLIST.ManualOrder')" align="center"></el-table-column>
                <el-table-column prop="date3" :label="$t('ORDERLIST.HotelName')" align="center"></el-table-column>
                <el-table-column prop="date1" :label="$t('MYORDER.Traveler')" align="center"></el-table-column>
                <el-table-column prop="date4" :label="$t('ORDERLIST.BookingDate')" min-width="95" align="center"></el-table-column>
                <el-table-column prop="date5" :label="$t('ORDERLIST.CheckInDate')" min-width="95" align="center"></el-table-column>
                <el-table-column prop="checkOutDate" :label="$t('ORDERLIST.CheckOutDate')" min-width="95" align="center"></el-table-column>
                <el-table-column prop="actualCheckInDate" :label="$t('ORDERLIST.ActualCheckInDate')" min-width="95" align="center"></el-table-column>
                <el-table-column prop="actualCheckOutDate" :label="$t('ORDERLIST.ActualCheckOutDate')" min-width="95" align="center"></el-table-column>
                <el-table-column prop="otherTravelerName" :label="$t('MYORDER.OtherTraveler')" align="center"></el-table-column>
                <el-table-column prop="date2" :label="$t('ORDERLIST.City')" align="center"></el-table-column>
                <el-table-column prop="date6" :label="$t('ORDERLIST.PaymentType')" align="center"></el-table-column>
                <el-table-column prop="date7" :label="$t('ORDERLIST.PaymentAmount')" align="center"></el-table-column>
                <el-table-column prop="customerCode" v-if="false"></el-table-column>
               <el-table-column :label="$t('ORDERLIST.Operation')" fixed="right" width="120" align="center">
                  <template #default="scope">
                    <div style="display: grid;grid-template-columns: repeat(auto-fit, minmax(35px, 1fr));">
                      <el-button @click="handleDetailClick(scope.row)" type="text" size="small">{{ $t("ORDERLIST.Detail") }}</el-button>
                      <el-button v-if="!scope.row.isDel && scope.row.date13 && currentTab == 'HotelOrder' && $objBaseInfo.sourceType == 'CRM'" @click="deleteRow(scope.row)" type="text" size="small">
                        {{ $t("ORDERLIST.DELETE") }}
                      </el-button>
                      <el-button v-if="$objBaseInfo.sourceType == 'CRM'" @click="openOperationLog(scope.row)" type="text" size="small">{{ $t("ORDERLIST.OPERATIONLOG") }}</el-button>
                      <el-button v-if="scope.row.date13 && currentTab == 'HotelOrder' && $objBaseInfo.sourceType == 'CRM'" @click="handleCopyDetailClick(scope.row)" type="text" size="small">复制</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
            <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
              <label v-if="$objBaseInfo.sourceType == 'CRM'" style="font-size:1.3rem;">共{{ checkDay }}间夜</label>
              <el-pagination style="float: right; margin: 1rem 0" background layout="total,prev, pager, next" :page-size="15" @current-change="handleCurrentChange" 
              :total="totalCount" v-model:current-page="Pageone" :key="destinationKey">
              </el-pagination>
            </el-footer>
          </div>
          <el-dialog width="98rem" class="dialog-one" v-model="bigOrderDialogInfo.dialogClient" :show-close="false">
            <Loading :loading="bigOrderloading" :isRelativeBrowserWin="false" />
            <el-tabs v-model="bigOrderDialogInfo.clientActiveName" type="card">
              <el-tab-pane :label="$t('BIGORDER.AddBigOrder')" name="first">
                <el-row>
                  <el-col :span="4" class="search-btn" @click="addBigOrder">
                    <el-button style="
                        padding: 7px 20px;
                        border: 1px solid #fc6640;
                        color: #fc6640;
                      ">
                      {{ $t("BIGORDER.CreateBigOrder") }}
                    </el-button>
                  </el-col>
                </el-row>
                <el-table :data="bigOrderDialogInfo.clientData">
                  <el-table-column prop="UserCodeName" :label="$t('BIGORDER.Client')" width="110"></el-table-column>
                  <el-table-column prop="BigOrderNo" :label="$t('BIGORDER.BigOrderNo')" width="200"></el-table-column>
                  <el-table-column prop="TravelerIdes" :label="$t('BIGORDER.UserName')" width="100"></el-table-column>
                  <el-table-column prop="TotalPrice" :label="$t('BIGORDER.TotalPrice')" width="100"></el-table-column>
                  <el-table-column prop="CreateBy" :label="$t('BIGORDER.CreateByName')" width="150"></el-table-column>
                  <el-table-column prop="CreateTime" :label="$t('BIGORDER.CreateTime')" width="200"></el-table-column>
                  <el-table-column width="120" :label="$t('BIGORDER.OPERATION')">
                    <template #default="scope">
                      <div class="select-btn" @click="selectBigOrder(scope.row)">
                        {{ $t("USERDIALOG.SELECT") }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row style="float: right; margin: 2%">
                  <el-pagination background layout="prev, pager, next" :total="bigOrderDialogInfo.pagination.total" :page-size="bigOrderDialogInfo.pagination.pageSize" :current-page="bigOrderDialogInfo.pagination.currentPage" @current-change="pageChange_bigOrderDialog">
                  </el-pagination>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-dialog>
          <!--删除el-dialog-->
          <el-dialog title="" v-model="deletedialogVisible" width="30rem">
            <div class="dialog-span-fixed">
              <div>
                <svg-icon icon-class="exclamation" style="vertical-align: -0.5em;"></svg-icon>
                <span style="margin-left:1rem;">请确认是否删除</span>
              </div>
            </div>
            <template #footer>
              <span class="dialog-footer">
                <button class="s_btn btn_dialog" @click="handleDeleteClick">
                  确 定
                </button>
                <el-button class="btn_dialog" style="padding: 0.2rem 2rem;" @click="cancelDelete">取 消</el-button>
              </span>
            </template>
            <!-- <span>请确认是否删除</span>
            <span slot="footer" class="dialog-footer">
              <el-button class="s_btn btn_dialog" @click="handleDeleteClick">确 定</el-button>
              <el-button @click="cancelDelete">取 消</el-button>
            </span> -->
          </el-dialog>
          <!--订单操作日志el-dialog-->
          <el-dialog width="98rem" class="dialog-one" v-model="operationLogInfo.dialogClient" :show-close="false">
            <Loading :loading="operationLogInfo.operationLogloading" :isRelativeBrowserWin="false" />
            <el-tabs v-model="operationLogInfo.clientActiveName" type="card">
              <el-tab-pane :label="$t('OPERATIONLOG.OrderOperationDetails')" name="first">
                <el-table :data="operationLogInfo.clientData">
                  <el-table-column prop="CreateDateTime" align="center" :label="$t('OPERATIONLOG.CreateTime')" width="200"></el-table-column>
                  <el-table-column prop="Operation" align="center" :label="$t('OPERATIONLOG.Operation')" width="200"></el-table-column>
                  <el-table-column prop="Description" align="center" :label="$t('OPERATIONLOG.Description')" width="300"></el-table-column>
                  <el-table-column prop="UserID" align="center" :label="$t('OPERATIONLOG.CreateById')" width="100"></el-table-column>
                  <el-table-column prop="Type" align="center" :label="$t('OPERATIONLOG.Type')" width="150"></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-dialog>
        </el-container>
      </el-container>

    </div>
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>

<script>
import {
  getBookingList,
  bookingsDownLoadExcel,
  getBigOrderList,
  updateBigOrder,
  createeBigOrder,
  BookingDelete,
  bookingsPreDownLoadExcel,
  CheckOrderCreator,
  getOperationLog,
} from "../../api/bookingData.js";
import Destination from "../../components/Destination.vue";
import {
  getCustomerLookup,
  getDeptSearch,
  getUserGetUserMenuList,
  travelerLookup,
} from "@/api/platformData";
import { formatDateTime, getFileName, hideElement } from "@/utils/utils.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import ClientList from "@/components/ClientList.vue";
import { deletelocationList } from "@/api/shoppingData";

export default {
  name: "OrderList",
  components: {
    Destination,
    ConfirmBoxs,
    Loading,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      deletedialogVisible: false,
      Pageone: 1,
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      chosenDepartmentId: "",
      bookingstatusvalue: "",
      //客户名称
      hotelCustomerCode: "",
      loading: false,
      orderloading: false,
      titlename: this.$t("ORDERINFO.PageTite"),
      datein: "",
      checkindate: "",
      totalCount: 0,
      dataForm: {
        city: {},
        cityCode: "",
        hotelname: "",
        datetype: "",
        travelerName: "",
        startDate: "",
        endDate: "",
        orderno: "",
        orderstatus: "",
        paymenttype: "",
      },
      hotelDataForm: {
        city: {},
        cityCode: "",
        client: "",
        hotelname: "",
        datetype: "",
        startDate: "",
        endDate: "",
        orderno: "",
        orderstatus: "",
        travelerName: "",
        paymenttype: "",
      },
      departmentDataForm: {
        city: {},
        cityCode: "",
        client: "",
        id: "",
        travelerName: "",
        hotelname: "",
        datetype: "",
        startDate: "",
        endDate: "",
        orderno: "",
        orderstatus: "",
        paymenttype: "",
      },
      detailParam: {
        cityCode: "",
        bookingCode: "",
        customerCode: "",
        departmentCode: "",
        hotelName: "",
        dateRange: {
          type: 1,
          startDate: null,
          endDate: null,
        },
        bookingStatus: "",
        paymentType: "",
        guestName: "",
        pageRequest: {
          pageNum: 1,
          pageLimit: 15,
          total: 0,
        },
      },
      pagenumber: 1,
      departmentoptions: [],
      traveleroptions: [],

      resultTable: [],
      cityList: [],
      hotelName: "",

      paymentType: {
        0: "OPTIONS.PAYMENTSTATUSAll", //全部
        1: "OPTIONS.PAYMENTSTATUSHotel", //到店付
        2: "OPTIONS.PAYMENTSTATUSpre", //预付
        3: "OPTIONS.PAYMENTSTATUSPublic", //公付
      },
      isMannulOrder: {
        true: "ORDERLIST.IsManualOrder",
        false: "ORDERLIST.IsnotManualOrder",
      },
      orderStatus: {
        BOOKED: "OPTIONS.OrderSUCCESS",
        CANCELLED: "OPTIONS.OrderCancel",
        CHECKOUT: "OPTIONS.OrderLeave",
        NOSHOW: "OPTIONS.OrderPaymentStatus",
        PENDING_CONFIRMATION: "OPTIONS.OrderPendingStatus",
        PENDING_BOOKING: "OPTIONS.PENDINGBOOKING",
        CWT_PENDING_CONFIRMATION: "OPTIONS.PENDINPROCESSED",
        CWT_PENDING_CANCELLATION: "OPTIONS.PENDINGCANCEL",
        CWT_PENDING_APPROVAL: "OPTIONS.CWT_PENDING_APPROVAL",
        BOOKING_FAILED: "预订失败",
      },
      activeName: "second",
      departmentOrderShow: false,
      hotelOrderShow: false,
      myOrderShow: true,
      currentTab: "",
      isOpenBigOrder: 0, //OBT 判断用户是否有开启加入大订单的权限 0 未开启 1 开启
      crmIsOpenBigOrder: 0, //CRM 判断用户是否有开启加入大订单的权限 0 未开启 1 开启
      selectCustomerCode:"",//选中订单的customercode
      bigOrderloading: false,
      bigOrderDialogInfo: {
        dialogClient: false,
        checkInOrder: false, //判断订单号是否已经迁入到大订单 TRUE 已迁入 FALSE 未迁入
        orderno: "",
        bigOrderCreateBy: "",
        bigOrderCreateName:"",
        clientActiveName: "first",
        clientData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1,
        }, //分页信息
      },
      operationLogInfo:{
        operationLogloading: false,
        dialogClient: false,
        clientActiveName: "first",
        clientData: [],
      },
      isShowList:this.$route.query.isShowList,
      destinationKey:0,//监控选择城市子组件
      checkDay:0,//入住天数
      isExportRemark:false,//是否导出订单备注
    };
  },
  computed: {
    tableData: function () {
      var arrTemp = [];
      var list = this.resultTable;
      for (var i = 0; i < list.length; i++) {
        const item = {
          date: list[i].bookingId,
          date1: list[i].travelerName,
          date2: list[i].citycode
            ? list[i].citycode[this.$t("MYORDER.RESPONSEDATA.city")]
            : "",
          date3: list[i].hotelName
            ? list[i].hotelName[this.$t("ORDERLIST.RESPONSEDATA.hotelName")]
            : "",
          date4: list[i].creationDate,
          date5: list[i].checkInDate,
          date6: this.$t(this.paymentType[list[i].paymentType]),
          date7: list[i].totalPrice,
          date8: this.$t("COMMONPARAM.ORDERSTATE." + list[i].bookingStatus),
          date9: list[i].customerName,
          date10: this.$t(this.isMannulOrder[list[i].mannalOrder]),
          date11: list[i].ItineraryOrder, //大订单号
          date12: list[i].CreatedBy, //订单创建人
          date13: JSON.parse(list[i].mannalOrder), //IsManualOrder
          customerCode: list[i].customerCode,
          otherTravelerName: list[i].otherTravelerName,
          checkOutDate: list[i].checkOutDate,
          actualCheckInDate: list[i].actualCheckInDate,
          actualCheckOutDate: list[i].actualCheckOutDate,
          isShowBilling: list[i].isShowBilling,
          isInternational: list[i].isInternational,
          isDel: list[i].isDel,
        };
        if(Object.prototype.hasOwnProperty.call(list[i],"approvalStatus"))
        {
          item.approvalStatus=this.$t("COMMONPARAM.APPROVALSTATUS." + list[i].approvalStatus);
        }
        arrTemp.push(item);
      }
      return arrTemp;
    },
    paymentoptions: function () {
      let result = [];
      for (let key in this.paymentType) {
        let item = {};
        item.value = key;
        item.label = this.$t(this.paymentType[key]);
        result.push(item);
      }
      return result;
    },
    datetypeoptions: function () {
      var result = [
        { label: this.$t("ORDERLIST.BookingDate"), value: "bookingDate" },
        { label: this.$t("ORDERLIST.CheckInDate"), value: "checkInDate" },
      ];
      return result;
    },
    orderstatusoptions: function () {
      let result = [];
      for (let key in this.orderStatus) {
        let item = {};
        item.value = key;
        item.label = this.$t("COMMONPARAM.ORDERSTATE." + key);
        result.push(item);
      }

      return result;
    },
  },
  mounted() {
    //this.getCustomerList(1);
    //-- CRM、OBT跳转处理 --
    //判断来源 CRM、OBT跳转过来隐藏部分元素
    hideElement(this);
    this.crmPath();
    //-- end ：：CRM、OBT跳转处理 --
    if(this.isShowList)
    {
      //设置默认参数
      if(Object.keys(this.$store.state.listSearch.listSearchDataForm).length>0)
      {
        this.dataForm=this.$store.state.listSearch.listSearchDataForm;
        this.destinationKey++;
      }
      if(Object.keys(this.$store.state.listSearch.listSearchModel).length>0)
      {
        this.detailParam=this.$store.state.listSearch.listSearchModel;
        this.pageNumber=this.detailParam.pageRequest.pageNum;
        this.Pageone=this.pageNumber;
      }
  
      this.monitorCity+=1;
      this.getOrderData(this.detailParam);
    }
  },
  methods: {
    //excel 导出
    async clickExport() {
      // bookingDate - 预订创建日期，checkInDate - 入住日期
      //请求接口
      let downParam = {};
      if (this.$objBaseInfo.sourceType == "CRM"){
        downParam = {
          customerCode: this.$route.query.customerCode
            ? this.$route.query.customerCode
            : null,
          customerName: this.$route.query.customerCode
            ? this.$objBaseInfo.customerName
            : null,
          guestNames: this.$route.query.spersons,
          cityCode: this.$route.query.stxtCityCode,
          checkInDate: this.$route.query.stxtStartTime
            ? this.$route.query.stxtStartTime
            : null,
          checkOutDate: this.$route.query.stxtEndTime
            ? this.$route.query.stxtEndTime
            : null,
          hotelName: this.$route.query.stxtHotelName
            ? this.$route.query.stxtHotelName
            : null,
          bookingId: this.$route.query.vOrderNo,
          bookingStatus: this.$route.query.orderStatus,
          chooseDate: this.$route.query.sDateTimeType
            ? this.$route.query.sDateTimeType
            : "checkInDate",
          paymentType: this.$route.query.paymentType
            ? parseInt(this.$route.query.paymentType)
            : 0,
          isInternational: this.$route.query.isInternational
            ? parseInt(this.$route.query.isInternational)
            : 0,
          PeopleType: this.$route.query.PeopleType
            ? parseInt(this.$route.query.PeopleType)
            : 0,
          Mobile: this.$route.query.Mobile
            ? this.$route.query.Mobile
            : "",
          Session: this.$route.query.bookingChannel
            ? this.$route.query.bookingChannel 
            : "",
          hotelType: this.$route.query.hotelType!=="" ? parseInt(this.$route.query.hotelType) : null,
          priceType: this.$route.query.priceType!=="" ? parseInt(this.$route.query.priceType) : null,
          hotelConfirmationNo: this.$route.query.hotelConfirmationNo,
          bookingChannel: this.$route.query.bookingChannel !=="" ? this.$route.query.bookingChannel : null,
          source: this.$route.query.source,
          invoiceNumber: this.$route.query.invoiceNumber,
          approvalStatus: this.$route.query.approvalStatus,
          isVirtualCard: this.$route.query.isVirtualCard,
          cbxMySelfSearch: this.$route.query.cbxMySelfSearch,
          from:"HotelOrder",
          isExportRemark:this.isExportRemark,
        };
      }else{
        var orderType = "";
        if (this.myOrderShow) {
          orderType = "MyOrder";
        } else if (this.hotelOrderShow) {
          orderType = "hotelOrder";
        } else if (this.departmentOrderShow) {
          orderType = "DeptOrder";
        }
        downParam = {
          customerCode: this.$route.query.customerCode
            ? this.$route.query.customerCode
            : null,
          customerName: this.$route.query.customerCode
            ? this.$objBaseInfo.customerName
            : null,
          guestNames: orderType == "DeptOrder"?this.departmentDataForm.travelerName:this.dataForm.travelerName,
          cityCode: orderType == "DeptOrder"?this.departmentDataForm.cityCode:this.dataForm.cityCode,
          checkInDate: orderType == "DeptOrder"?
          (this.departmentDataForm.startDate? formatDateTime(this.departmentDataForm.startDate, "YYYY-MM-DD"): null):
          (this.dataForm.startDate? formatDateTime(this.dataForm.startDate, "YYYY-MM-DD"): null),
          checkOutDate: orderType == "DeptOrder"?
          (this.departmentDataForm.endDate? formatDateTime(this.departmentDataForm.endDate, "YYYY-MM-DD"): null):
          (this.dataForm.endDate? formatDateTime(this.dataForm.endDate, "YYYY-MM-DD"): null),
          hotelName: orderType == "DeptOrder"?this.departmentDataForm.hotelName:this.dataForm.hotelName,
          bookingId: orderType == "DeptOrder"?this.departmentDataForm.orderno.trim():this.dataForm.orderno.trim(),
          bookingStatus:  orderType == "DeptOrder"?
          (this.departmentDataForm.orderstatus != ""? this.departmentDataForm.orderstatus + '': ""):
          (this.dataForm.orderstatus != ""? this.dataForm.orderstatus + '': ""),
          chooseDate: orderType == "DeptOrder"?this.departmentDataForm.datetype:this.dataForm.datetype,
          paymentType: orderType == "DeptOrder"?
          (this.departmentDataForm.paymenttype != ""? this.departmentDataForm.paymenttype: ""):
          (this.dataForm.paymenttype != ""? this.dataForm.paymenttype: ""),
          isInternational: 0,
          PeopleType: 0,
          Mobile: "",
          Session: "",
          hotelType: null,
          priceType: null,
          hotelConfirmationNo: "",
          bookingChannel:  null,
          source: "",
          invoiceNumber: "",
          approvalStatus: "",
          from:orderType,
          dptCode:orderType == "DeptOrder"?this.departmentDataForm.id.toString():null,
          isExportRemark:false,
        };
      }
      
      this.orderloading = true;
      await bookingsPreDownLoadExcel(downParam)
        .then((preRes) => {
          this.orderloading = false;
          if (preRes.code == 200) {
            if (preRes.data.error.code == 0) {
              //开始下载
              this.$message(this.$t("MESSAGE.DOWNLOADSTART"));
              bookingsDownLoadExcel(downParam)
                .then((res) => {
                  // 执行下载
                  const downloadLink = document.createElement("a");
                  const downloadUrl = URL.createObjectURL(new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })); // 字节转成 Blob
                  // 设置下载文件名
                  const fileName = String(getFileName() || "order").replace(/[^a-zA-Z0-9_-]/g, "");
                  // .csv 文件后缀
                  downloadLink.download = (fileName || "order") + ".xls"; // 文件名称
                  downloadLink.style.display = "none";
                  //csv文件的type  text/csv    xls:application/vnd.ms-excel
                  downloadLink.href = downloadUrl;
                  downloadLink.click();
                  setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
                })
                .catch((error) => {
                  console.log("导出Excel", error);
                });
            } else {
              this.confirmFlag = true;
              this.confirmMsg = this.$t("ERRORMESSAGE." + preRes.data.error.code) === "ERRORMESSAGE." + preRes.data.error.code ? this.$t("ERRORMESSAGE.NOTFOUND") : this.$t("ERRORMESSAGE." + preRes.data.error.code);
              console.log("导出Excel预下载执行失败, code:" , preRes.code, preRes.message);
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = this.$t("ERRORMESSAGE.500");
            console.log("导出Excel预下载执行失败");
          }
        })
        .catch((error) => {
          this.orderloading = false;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + error.mesCode);
          console.log("导出Excel预下载执行异常", error.objError);
        });
    },
    crmPath() {
      this.currentTab = "";
      //this.isOpenBigOrder= 0;  
      if (this.$objBaseInfo.sourceType == "CRM") {
        this.hotelOrderShow = true;
        this.myOrderShow = false;
        this.departmentOrderShow = false;
        this.currentTab = "HotelOrder";
        if(this.$route.query.customerCode == undefined||this.$route.query.customerCode == '')
        {
          this.isOpenBigOrder = 1
        }
        else
        {
          this.isOpenBigOrder = this.$route.query.isOpenBigOrder
          ? parseInt(this.$route.query.isOpenBigOrder)
          : 0; //开启大订单权限
        }
        let paramsHotelData = {};
        paramsHotelData.from = "HotelOrder";
        paramsHotelData.cityCode = this.$route.query.stxtCityCode; //客户名称
        if (this.$route.query.vOrderNo)
          paramsHotelData.bookingCode = this.$route.query.vOrderNo; //
        paramsHotelData.customerCode = this.$route.query.customerCode
          ? this.$route.query.customerCode
          : ""; //this.$objBaseInfo.customerCode; //sUserCode;
        paramsHotelData.departmentCode = "";
        if (this.$route.query.stxtHotelName)
          paramsHotelData.hotelName = this.$route.query.stxtHotelName;
        paramsHotelData.dateRange = {};
        paramsHotelData.dateRange.type = this.$route.query.sDateTimeType
          ? this.$route.query.sDateTimeType
          : "checkInDate"; //时间类型  --预订时间，入住时间
        paramsHotelData.dateRange.startDate = this.$route.query.stxtStartTime
          ? this.$route.query.stxtStartTime
          : null; //
        paramsHotelData.dateRange.endDate = this.$route.query.stxtEndTime
          ? this.$route.query.stxtEndTime
          : null; //
        paramsHotelData.bookingStatus = this.$route.query.orderStatus;
        paramsHotelData.paymentType = this.$route.query.paymentType
          ? parseInt(this.$route.query.paymentType)
          : 0; //支付类型
        paramsHotelData.guestName = this.$route.query.spersons; //入住人
        paramsHotelData.sourceBookingId = this.$route.query.sourceBookingId; //供应商订单号
        paramsHotelData.hotelConfirmationNo = this.$route.query.hotelConfirmationNo; //酒店确认号
        //酒店类型
        paramsHotelData.hotelType = this.$route.query.hotelType!=="" ? parseInt(this.$route.query.hotelType) : null; //枚举值：0：非协议，1：公司协议，2：CWT协议
        paramsHotelData.priceType = this.$route.query.priceType!=="" ? parseInt(this.$route.query.priceType) : null; //枚举值：0：非协议，1：公司协议，2：CWT协议
        paramsHotelData.bookingChannel = this.$route.query.bookingChannel !=="" ? this.$route.query.bookingChannel : null; //预定来源 多选(例如："1,2,3"); (枚举值: 0：APP，1：OBT，2：CRM代客下单，3：CRM补录订单，4：H5，6：ClientAPI)
        paramsHotelData.source = this.$route.query.source; //供应商 多选格,式同预定来源 （枚举值：all：全部，sabre：Sabre，elong：ELong，fuxun：FuXun，dongcheng：东呈，huazhu：华住，atour：亚朵，rujia：如家）

        paramsHotelData.pageRequest = {
          pageNum: this.pagenumber,
          pageLimit: this.$route.query.pageLimit,
          total: 0,
        };
        paramsHotelData.isInternational=this.$route.query.isInternational;
        paramsHotelData.PeopleType=this.$route.query.PeopleType;
        paramsHotelData.Mobile=this.$route.query.Mobile;
        paramsHotelData.invoiceNumber=this.$route.query.invoiceNumber;
        paramsHotelData.approvalStatus=this.$route.query.approvalStatus;
        paramsHotelData.isVirtualCard=this.$route.query.isVirtualCard;
        paramsHotelData.cbxMySelfSearch=this.$route.query.cbxMySelfSearch;
        this.getOrderData(paramsHotelData);
      } else if (this.$objBaseInfo.sourceType == "OBT") {
        if (this.$route.query.menuType == "myOrderList") {
          this.isOpenBigOrder = this.$route.query.isOpenBigOrder
            ? parseInt(this.$route.query.isOpenBigOrder)
            : 0; //开启大订单权限
          document.getElementById("li-myOrder").click();
        } else if (this.$route.query.menuType == "departmentOrderList") {
          document.getElementById("li-departmentOrder").click();
        }
      }
    },
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.hotelDataForm.client = item.customerName;
    },
    //获取travelerList
    async getTravelerList(code) {
      try {
        this.Code = code ? code : "";
        this.deptCode = this.chosenDepartmentId ? this.chosenDepartmentId : "";
        let params = {
          params: {
            travelerCode: this.Code,
            deptCode: this.deptCode,
          },
        };
        const res = await travelerLookup(params);
        this.traveleroptions = res.data.travelerList;
      } catch (e) {
        console.log(e);
      }
    },
    //获取部门
    async getDepartment() {
      try {
        let params = {
          params: {
            customerCode: this.$objBaseInfo.customerCode,
            deptIDs: this.$objBaseInfo.viewDepIDs,
          },
        };
        const res = await getDeptSearch(params);
        this.departmentoptions = res.data.items;
      } catch (e) {
        console.log(e);
      }
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    setDestination(value) {
      this.dataForm.cityCode = value.cityCode;
      this.dataForm.city = value;
    },
    sethotelDestination(value) {
      this.hotelDataForm.cityCode = value.cityCode;
      this.hotelDataForm.city = value;
    },
    setdepartDestination(value) {
      this.departmentDataForm.cityCode = value.cityCode;
      this.hotelDataForm.city = value;
    },

    async getOrderData(detailParam) {
      this.orderloading = true;
      let that = this;
      var arrTemp = [];

      await getBookingList(detailParam)
        .then((res) => {
          if (res.code == 200) {
            // console.log("hotelOrder Detail酒店订单信息详情", res);
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);
              that.orderloading = false;
              that.tableData.splice(0, that.tableData.length);
              that.totalCount = 0;
            } else {
              for (var i = 0; i < res.data.reservationSummaryList.length; i++) {
                var response = res.data.reservationSummaryList[i];
                const item = {
                  cityCode: res.data.reservationSummaryList[i].cityCode,
                  citycode: res.data.reservationSummaryList[i].cityName,
                  bookingId: response.bookingId,
                  paymentType: res.data.reservationSummaryList[i].paymentType,
                  bookingStatus: res.data.reservationSummaryList[i].isDel?
                    "CWT_DELETE":
                    res.data.reservationSummaryList[i].bookingStatus, //self.bookingstatusvalue,
                  travelerName: response.guestNames,
                  otherTravelerName: response.otherGuestNames,
                  hotelName: response.hotelName,
                    creationDate: response.creationDate ? formatDateTime(response.creationDate, "YYYY/MM/DD") : null,
                    checkInDate: response.checkInDate ? formatDateTime(response.checkInDate, "YYYY/MM/DD") : null,
                    checkOutDate: response.checkOutDate ? formatDateTime(response.checkOutDate, "YYYY/MM/DD") : null,
                    actualCheckInDate: response.actualCheckInDate ? formatDateTime(response.actualCheckInDate, "YYYY/MM/DD") : null,
                    actualCheckOutDate: response.actualCheckOutDate ? formatDateTime(response.actualCheckOutDate, "YYYY/MM/DD") : null,
                  totalPrice: that.$currencySign[response.currencyCode] + response.totalPrice,
                  customerName: response.customerName,
                  customerCode: response.customerCode,
                  mannalOrder: response.isManualOrder.toString(),
                  ItineraryOrder: response.itineraryOrder,
                  CreatedBy: response.createdBy,
                  isShowBilling:response.isShowBilling,
                  isInternational:response.isInternational,
                  isVirtualCard:response.isVirtualCard,
                  isDel: response.isDel
                };
                if(Object.prototype.hasOwnProperty.call(response,"approvalStatus"))
                {
                  item.approvalStatus=response.approvalStatus;
                }
                arrTemp.push(item);
              }
              that.totalCount = res.data.pagination.total;
              that.checkDay = res.data.checkDay;
              that.resultTable = arrTemp;
              that.orderloading = false;
              that.pagenumber = 1;
            }
          } else {
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log("getBookingList, code:" , res.code, res.message);
          }
        })
        .catch(function (error) {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          that.orderloading = false;
          that.tableData.splice(0, that.tableData.length);
          that.totalCount = 0;
          console.log("getBookingList", error);
        });
    },
    departmentchange(id) {
      this.chosenDepartmentId = id.toString();
      this.departmentDataForm.travelerName = "";
      this.getTravelerList();
    },
    handleClick(tab) {
      //switch tab will delete all the search items
      Object.keys(this.dataForm).forEach((key) => {
        this.dataForm[key] = "";
      });
      Object.keys(this.hotelDataForm).forEach((key) => {
        this.hotelDataForm[key] = "";
      });
      Object.keys(this.departmentDataForm).forEach((key) => {
        this.departmentDataForm[key] = "";
      });
      this.totalCount = 0;
      this.hotelCustomerCode = "";
      if (tab == "departmentOrder") {
        if (this.$objBaseInfo.viewBy == 0) {
          this.getDepartment();
        } else if (this.$objBaseInfo.viewBy == 1) {
          this.getTravelerList(this.$objBaseInfo.viewUserIDs);
        }
        this.departmentOrderShow = true;
        this.hotelOrderShow = false;
        this.myOrderShow = false;
        this.titlename = this.$t("ORDERINFO.DepartmentOrderTitle");
        this.tableData.splice(0, this.tableData.length);
        if(!this.isShowList){
          this.departmentDataForm.endDate = new Date();
          this.departmentDataForm.startDate = new Date().getTime() - 3600 * 1000 * 24 * 90;
          this.departmentDataForm.datetype = "bookingDate";
          this.SearchClick(tab);
        }
      } else if (tab == "hotelOrder") {
        this.departmentOrderShow = false;
        this.hotelOrderShow = true;
        this.myOrderShow = false;
        this.titlename = this.$t("ORDERINFO.HotelOrderTitle");
        this.tableData.splice(0, this.tableData.length);
        if(!this.isShowList){
          this.hotelDataForm.endDate = new Date();
          this.hotelDataForm.startDate = new Date().getTime() - 3600 * 1000 * 24 * 90;
          this.hotelDataForm.datetype = "bookingDate";
          this.SearchClick(tab);
        }
      } else if (tab == "myOrder") {
        this.tableData.splice(0, this.tableData.length);
        this.departmentOrderShow = false;
        this.hotelOrderShow = false;
        this.myOrderShow = true;
        this.titlename = this.$t("ORDERINFO.MyOrderTitle");
        if(!this.isShowList){
          this.dataForm.endDate = new Date();
          this.dataForm.startDate = new Date().getTime() - 3600 * 1000 * 24 * 90;
          this.dataForm.datetype = "bookingDate";
          this.SearchClick(tab);
        }
      } else {
        this.departmentOrderShow = false;
        this.hotelOrderShow = false;
        this.myOrderShow = false;
        this.titlename = this.$t("ORDERINFO.PageTite");
      }
      // console.log(tab);
    },
    handleDetailClick(row) {
      debugger
      if (this.hotelOrderShow) {
        let message = {};
        //url：酒店详情页面地址, orderNo：酒店订单号, userCode：CusomterCode
        message.url = location.origin + process.env.BASE_URL + "confirmation";
        message.orderNo = row.date;
        message.userCode = row.customerCode;
        message.isInternational = row.isInternational;
        window.parent.postMessage(message, "*");
      } else {
        //赋值默认参数
        this.$store.state.listSearch.searchParam=this.$route.query.searchParam;
        this.$store.state.listSearch.menuType=this.$route.query.menuType;
        this.$store.state.listSearch.lang=this.$route.query.lang;
        this.$store.state.listSearch.token=this.$route.query.token;
        this.$store.state.listSearch.sourceType=this.$route.query.sourceType;
        this.$store.state.listSearch.isOpenBigOrder=this.$route.query.isOpenBigOrder;

        this.$store.state.listSearch.listSearchDataForm=this.dataForm;
        this.$store.state.listSearch.listSearchModel=this.detailParam;

        this.$router.push({
          name: "Confirmation",
          query: {
            orderId: row.date,
            customerCode: row.customerCode,
            sourceType: this.$objBaseInfo.sourceType,
            isShowBtn:true,
          },
        });
      }
    },
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          bookingCode: row.date,
        },
      };
    },
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    async handleDeleteClick() {
      this.orderloading = true;
      this.deletedialogVisible = false;
      await BookingDelete(this.deleteparams)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              this.orderloading = false;
              // this.deletedialogVisible = false;
              this.confirmFlag = true;
              this.confirmMsg = res.data.error.message;

              console.log(
                "删除请求失败, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              this.orderloading = false;
              // this.deletedialogVisible = false;
              this.confirmFlag = true;
              this.confirmMsg = "删除成功";
              // this.SearchClick();
              this.crmPath();
            }
          } else {
            this.orderloading = false;
            // this.deletedialogVisible = false;
            console.log("删除请求失败, code:" , res.code, res.message);
          }
        })
        .catch((err) => {
          this.orderloading = false;
          console.log("删除请求失败", err);
        });
    },
    //分页
    handleCurrentChange(pageNum) {
      // console.log(pageNum)
      if (this.$objBaseInfo.sourceType == "CRM") {
        this.pagenumber = pageNum;
        this.crmPath();
      } else {
        this.pagenumber = pageNum;
        let orderType = "";
        if (this.myOrderShow) {
          orderType = "myOrder";
        } else if (this.hotelOrderShow) {
          orderType = "hotelOrder";
        } else if (this.departmentOrderShow) {
          orderType = "departmentOrder";
        }
        this.SearchClick(orderType);
        this.Pageone = pageNum;
      }
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    SearchClick(orderType) {
      var from = "";
      var Department = "";
      var DateType;
      var StartDate = "";
      var EndDate = "";
      var HotelName = "";
      var cityCode = "";
      var OrderStatus = "";
      var OrderNo = "";
      var PaymentType = 0;
      var Traveler = "";
      var Client = "";
      if (orderType == "departmentOrder") {
        from = "DeptOrder";
        cityCode = this.departmentDataForm.cityCode;
        Client = this.$objBaseInfo.customerCode;
        Department = this.departmentDataForm.id.toString();
        DateType = this.departmentDataForm.datetype;
        StartDate = this.departmentDataForm.startDate
          ? formatDateTime(this.departmentDataForm.startDate, "YYYY-MM-DD")
          : null;
        EndDate = this.departmentDataForm.endDate
          ? formatDateTime(this.departmentDataForm.endDate, "YYYY-MM-DD")
          : null;
        HotelName = this.departmentDataForm.hotelName;
        OrderNo = this.departmentDataForm.orderno.trim();
        Traveler = this.departmentDataForm.travelerName;
        // console.log(OrderNo)
        if (this.departmentDataForm.orderstatus != "") {
          OrderStatus = this.departmentDataForm.orderstatus;
        }
        if (this.departmentDataForm.paymenttype != "") {
          PaymentType = this.departmentDataForm.paymenttype;
        }
      } else if (orderType == "hotelOrder") {
        from = "HotelOrder";
        Client = this.hotelCustomerCode ? this.hotelCustomerCode : ""; //this.$objBaseInfo.customerCode;
        cityCode = this.hotelDataForm.cityCode;
        DateType = this.hotelDataForm.datetype;
        StartDate = this.hotelDataForm.startDate
          ? formatDateTime(this.hotelDataForm.startDate, "YYYY-MM-DD")
          : null;
        EndDate = this.hotelDataForm.endDate
          ? formatDateTime(this.hotelDataForm.endDate, "YYYY-MM-DD")
          : null;
        HotelName = this.hotelDataForm.hotelName;
        if (this.hotelDataForm.orderstatus != "") {
          OrderStatus = this.hotelDataForm.orderstatus;
        }
        if (this.hotelDataForm.paymenttype != "") {
          PaymentType = this.hotelDataForm.paymenttype;
        }
        OrderNo = this.hotelDataForm.orderno.trim();
        Traveler = this.hotelDataForm.travelerName;
      } else if (orderType == "myOrder") {
        from = "MyOrder";
        cityCode = this.dataForm.cityCode;
        Client = this.$objBaseInfo.customerCode;
        DateType = this.dataForm.datetype;
        StartDate = this.dataForm.startDate
          ? formatDateTime(this.dataForm.startDate, "YYYY-MM-DD")
          : null;
        EndDate = this.dataForm.endDate
          ? formatDateTime(this.dataForm.endDate, "YYYY-MM-DD")
          : null;
        HotelName = this.dataForm.hotelName;
        OrderNo = this.dataForm.orderno.trim();
        Traveler = this.dataForm.travelerName;
      }
      //日期校验
      if (
        ((StartDate == null && EndDate == null) ||
          (StartDate == null && EndDate != null) ||
          (EndDate == null && StartDate != null)) &&
        DateType != ""
      ) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("ORDERLIST.CONFIRMCHECK");
        this.confirmFlag = true;
      } else if (EndDate != null && StartDate != null && DateType == "") {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("ORDERLIST.WARNING");
        this.confirmFlag = true;
      } else if (StartDate > EndDate) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("ORDERLIST.TIMECHECK");
        this.confirmFlag = true;
      } else {
        if (this.dataForm.orderstatus != "") {
          OrderStatus = this.dataForm.orderstatus;
        }
        if (this.dataForm.paymenttype != "") {
          PaymentType = this.dataForm.paymenttype;
        }
        this.Pageone = 1;
        // if (StartDate == "") {
        //   StartDate = null;
        // }
        // if (EndDate == "") {
        //   EndDate = null;
        // }
        // if(from == ""){
        //   from = "HotelOrder";
        // }
        this.detailParam = {
          from: from,
          cityCode: cityCode,
          bookingCode: OrderNo,
          customerCode: Client,
          departmentCode: Department,
          hotelName: HotelName,
          dateRange: {
            type: DateType,
            startDate: StartDate,
            endDate: EndDate,
          },
          bookingStatus: OrderStatus + "",
          paymentType: PaymentType,
          guestName: Traveler,
          pageRequest: {
            pageNum: this.pagenumber,
            pageLimit: 15,
            total: 0,
          },
        };
        this.getOrderData(this.detailParam);
      }
    },
   async showBigOrder() {
      let that = this;
      const _selectData = this.$refs.orderListTable.getSelectionRows();

      if (_selectData.length == 0) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.11302");
        return false;
      } else {
        var createByResult = _selectData[0].date12;
        this.bigOrderDialogInfo.selectCustomerCode = _selectData[0].customerCode;
        for (var i = 0; i < _selectData.length; i++) {
          if (this.$objBaseInfo.sourceType == "CRM" && this.bigOrderDialogInfo.selectCustomerCode !== _selectData[i].customerCode)
          {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11303");
            return false;
          }
          if (_selectData[i].date11 != null) {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11301", {
              OrderNo: _selectData[i].date,
              ItineraryOrder: _selectData[i].date11,
            });
            return false;
          }
        }
      }
      var arrTemp = [];
      for (var i = 0; i < _selectData.length; i++) {
        arrTemp.push(_selectData[i].date);
      }
      let checkOrderCreatorParam = {
        LoginId: that.$objBaseInfo.loginID,
        sourceType: that.$objBaseInfo.sourceType,
        Orders: arrTemp,
      };
      await CheckOrderCreator(checkOrderCreatorParam).then
      ((res) => {
        if (res.code == 200) {
          if(!res.data.result)
          {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11303");
            return false;
          }
          else
          {
            this.bigOrderDialogInfo.bigOrderCreateBy = res.data.userId;
            this.bigOrderDialogInfo.bigOrderCreateName = this.$objBaseInfo.sourceType == "CRM"?this.$objBaseInfo.loginID : res.data.userName;
            if(this.$objBaseInfo.sourceType == "CRM")
            {
              this.checkCustomerIsOpenBigOrder().then
              (() => {
              if(that.bigOrderDialogInfo.crmIsOpenBigOrder == 0)
              {
                that.confirmFlag = true;
                that.confirmMsg = that.$t("ERRORMESSAGE.11306");
                return false;
              }
              this.getBigOrderData(1);
              that.bigOrderDialogInfo.checkInOrder = false;
              that.bigOrderDialogInfo.dialogClient = true;
              })
            }
            else
            {
              this.getBigOrderData(1);
              that.bigOrderDialogInfo.checkInOrder = false;
              that.bigOrderDialogInfo.dialogClient = true;
            }
          }
        }
      })
    },
    async getBigOrderData(currPage) {
      var arrTemp = [];
      let that = this;
      that.bigOrderloading = true;
      let bigOrderParam = {
        loginID: this.bigOrderDialogInfo.bigOrderCreateBy,
        userCode: this.bigOrderDialogInfo.selectCustomerCode,
        sourceType: that.$objBaseInfo.sourceType,
        pageRequest: {
          pageNum: currPage,
          pageLimit: 5,
          total: 0,
        },
      };
      await getBigOrderList(bigOrderParam)
        .then((res) => {
          if (res.code == 200) {
            console.log("大订单列表信息", res.data.orderData);
            that.bigOrderDialogInfo.pagination.total = res.data.recordCount; //总数
            that.bigOrderDialogInfo.pagination.pageSize = res.data.pageSize;
            that.bigOrderDialogInfo.pagination.currentPage = res.data.pageIndex;
            if (res.data.orderData != null) {
              for (var i = 0; i < res.data.orderData.length; i++) {
                var response = res.data.orderData[i];
                const item = {
                  UserCodeName: response.userCodeName,
                  BigOrderNo: response.bigOrderNo,
                  TravelerIdes: response.travelerIdes,
                  TotalPrice: response.totalPrice,
                  CreateBy: response.createBy,
                  CreateTime: formatDateTime(response.createTime, "YYYY-MM-DD HH:mm:ss"), //? formatDateTime(response.createTime, "YYYY-MM-DD") : null
                };
                arrTemp.push(item);
              }
            }
            that.bigOrderDialogInfo.clientData = arrTemp;
          }
          that.bigOrderloading = false;
        })
        .catch(function (error) {
          that.bigOrderloading = false;
          console.log("大订单信息 请求失败", error);
        });
    },
    //大订单列表分页切换
    pageChange_bigOrderDialog(currPage) {
      this.getBigOrderData(currPage);
    },
    //选择大订单
    async selectBigOrder(row) {
      let that = this;
      if (that.bigOrderDialogInfo.checkInOrder) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.11302");
        return;
      }
      that.bigOrderloading = true;
      const _selectData = this.$refs.orderListTable.getSelectionRows();;
      var orderNo = "";
      //createeBigOrder
      for (var i = 0; i < _selectData.length; i++) {
        orderNo += _selectData[i].date + ",";
      }
      let bigOrderParam = {
        loginID: this.bigOrderDialogInfo.bigOrderCreateBy,
        userCode: this.bigOrderDialogInfo.selectCustomerCode,
        userName: this.bigOrderDialogInfo.bigOrderCreateName,
        sourceType: that.$objBaseInfo.sourceType,
        last_OrderNo: orderNo.substring(0,orderNo.length-1),
        next_OrderNo: row.BigOrderNo,
      };
      await updateBigOrder(bigOrderParam)
        .then((res) => {
          if (res.code == 200) {
            that.bigOrderDialogInfo.checkInOrder = true;
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11304");
            that.getBigOrderData(1);
            if (this.$objBaseInfo.sourceType == "OBT") {
              that.SearchClick("myOrder");
            } else {
              this.crmPath();
            }
            that.bigOrderloading = false;
          }
          else
          {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11305");
            that.bigOrderloading = false;
          }
        })
        .catch(function (error) {
          that.bigOrderloading = false;
          console.log("大订单信息 加入大订单失败", error);
        });
    },
    //添加大订单
    async addBigOrder() {
      let that = this;
      if (that.bigOrderDialogInfo.checkInOrder) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.11302");
        return;
      }
      that.bigOrderloading = true;
      const _selectData = this.$refs.orderListTable.getSelectionRows().sort((a, b) => {
        return new Date(a.date5).getTime() - new Date(b.date5).getTime();
      });
      var orderNo = "";
      //createeBigOrder
      for (var i = 0; i < _selectData.length; i++) {
        orderNo += _selectData[i].date + ",";
      }
      let bigOrderParam = {
        loginID: this.bigOrderDialogInfo.bigOrderCreateBy,
        userCode: this.bigOrderDialogInfo.selectCustomerCode,
        userName: this.bigOrderDialogInfo.bigOrderCreateName,
        sourceType: that.$objBaseInfo.sourceType,
        last_OrderNo: orderNo.substring(0,orderNo.length-1),
      };
      await createeBigOrder(bigOrderParam)
        .then((res) => {
          if (res.code == 200) {
            that.bigOrderDialogInfo.checkInOrder = true;
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11304");
            that.getBigOrderData(1);
            if (this.$objBaseInfo.sourceType == "OBT") {
              that.SearchClick("myOrder");
            } else {
              this.crmPath();
            }
            that.bigOrderloading = false;
          }
          else
          {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE.11305");
            that.bigOrderloading = false;
          }
        })
        .catch(function (error) {
          that.bigOrderloading = false;
          console.log("大订单信息 生成新大订单失败", error);
        });
    },
    //验证客户是否开启大订单
    async checkCustomerIsOpenBigOrder() {
      let customerParam = {
        params: {
          page: 1,
          per_page: 5,
          customerCode: this.bigOrderDialogInfo.selectCustomerCode,
          customerName:'',
        },
      };
      await getCustomerLookup(customerParam)
        .then((res) => {
          if(res.code == 200 && res.data.customerDetails.length > 0)
          {
            this.bigOrderDialogInfo.crmIsOpenBigOrder = res.data.customerDetails[0].isOpenBigOrder;
          }
        })
        .catch(function (error) {
          console.log("客户信息 请求失败", error);
        });
    },
    async openOperationLog(row) {
      var arrTemp = [];
      let that = this;
      this.operationLogInfo.dialogClient = true;
      that.operationLogInfo.operationLogloading = true;
      let operationLogParam = {
        params: {
          bookingCode: row.date,
        },
      };
      await getOperationLog(operationLogParam)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.orderOperationLogInfo != null) {
              for (var i = 0; i < res.data.orderOperationLogInfo.length; i++) {
                var response = res.data.orderOperationLogInfo[i];
                const item = {
                  CreateDateTime: formatDateTime(response.createDateTime,"YYYY-MM-DD HH:mm:ss"),
                  Description: response.description,
                  UserID: response.userID,
                  Operation: response.operation,
                  Type: response.type,
                };
                arrTemp.push(item);
              }
            }
            that.operationLogInfo.clientData = arrTemp;
          }
          that.operationLogInfo.operationLogloading = false;
        })
        .catch(function (error) {
          that.operationLogInfo.operationLogloading = false;
          console.log("订单操作日志 请求失败", error);
        });
    },
    handleCopyDetailClick(row){
      let message = {};
      //url：酒店详情页面地址, orderNo：酒店订单号, userCode：CusomterCode
      message.url = location.origin + process.env.BASE_URL + "manualOrder";
      message.orderNo = row.date;
      message.userCode = row.customerCode;
      message.title = "酒店补录订单";
      window.parent.postMessage(message, "*");
    }
  },
};
</script>

<style scoped>
::v-deep .cell {
  word-break: break-word;
}
::v-deep .el-input__icon {
  height: auto;
  width: 2.5rem;
  text-align: center;
  line-height: 0;
}
::v-deep .el-table__empty-block {
  min-height: 60px;
  text-align: left;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .dialog-one .el-dialog__header,
::v-deep .dialog-one .el-tabs__active-bar {
  display: none;
}

::v-deep .el-input__inner {
  height: 2.7rem;
  line-height: 2.7rem;
}

.myBtn /deep/ .el-button {
  padding: 7px 20px !important;
  border: 1px solid #fc6640 !important;
  color: #fc6640 !important;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}

.select-btn {
  color: #fc6640;
  cursor: pointer;
}

.search-btn {
  margin: 2% 5%;
}

.box {
  display: flex;
  width: 100%;
  background-color: #ffffff;
  height: 2.7rem;
}

.box_1 {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 0.2rem solid #fc6640;
}

.box_2 {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 0.2rem solid #fc6640;
}

.box_1:hover {
  cursor: pointer;
}

.box_2:hover {
  cursor: pointer;
}

.box_2:focus {
  background-color: #fc6640;
}

.box_1:focus {
  background-color: #fc6640;
}

.tabs_item /deep/ .el-tabs__item {
  padding-left: 17rem !important;
  /*padding-right: 20px;*/
}

.tabs_header /deep/ .el-tabs__header {
  background-color: #ffffff;
  margin: 0;
}

.tabs_item_first /deep/ .el-tabs__item {
  padding: 0 20rem !important;
}

.tabs_item_second /deep/ .el-tabs__item {
  padding: 0 3.5rem !important;
}

.clear-icon /deep/ .el-range__icon {
  width: 0;
}

.table_inner /deep/ .el-table__header {
  width: auto !important;
}

.tablecontent_inner /deep/ .el-table__body {
  width: auto !important;
}

.icon_inner /deep/ .el-range-separator {
  line-height: 2rem;
}

.timeicon_inner /deep/ .el-input__icon {
  margin-top: 0.5rem;
}

.myinput_inner /deep/ .el-input__inner {
  height: 2.7rem;
  border-radius: 0;
  /* width: 18vw; */
  /* margin-top: 1rem; */
}

/deep/ .el-date-editor.el-input {
  width: 100%;
}

.myselect_inner /deep/ .el-input__inner {
  height: 2.7rem;
  border-radius: 0;
  /* margin-top: 1rem; */
}

.myicon_inner /deep/ .el-input__suffix {
  top: 0.2rem;
}

/deep/ .el-select {
  width: 100%;
}

.content_size {
  margin-bottom: 1rem !important;
}

.center_sty {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.grey_small_font {
  height: 20px;
  font-size: 14px;
  color: #6f787e;
  margin-bottom: 1rem;
  display: inline-block;
}

.el-date-picker /deep/ .el-input__inner {
  height: 2.7rem;
  width: 100%;
  border-radius: 0;
}

.el-date-picker /deep/ .el-input__icon {
  line-height: 2.8rem;
}

.div_select_panel {
  padding: 0 2rem;
  background-color: #ffffff;
}

.div_main_table {
  background: #fff;
  margin: 0 2rem;
}
.cell button{
  margin-left:0;
}
</style>
